import React, { useState, useContext, Suspense, lazy, useEffect, useRef, useMemo } from 'react';
import { Outlet, Route, Routes, useLocation, Navigate, useNavigate } from 'react-router-dom';
import PcLayout from '../layout/pc';
import { AppContext } from '@utils/AppContext';
import eventBus from '@utils/eventBus';


import HomemainLayout from "@view/page_v3/Layout"
import AiEdit from "@view/page_v3/AiEdit/aiEdit";
import MyProjectList from "@view/page_v3/MyProject/ProjectListPage";
import MyProjectDetail from "@view/page_v3/MyProject/ProjectDetailPage";
import FavorDetail from '@view/page/PhotoProjectDetail/favoriteIndex'
import PhotoProjectDetail from "@view/page/PhotoProjectDetail";
import PersonalSidebar from "@view/page_v3/PersonalCenter/PersonalSidebar";
import PersonalTransaction from "@view/page_v3/PersonalCenter/PersonalTransaction";
import PersonalOrder from "@view/page_v3/PersonalCenter/PersonalOrder";
import PersonalInformation from "@view/page_v3/PersonalCenter/PersonalInformation";
import MemberManage from "@view/page_v3/PersonalCenter/MemberManage";
import RedemptioncodeList from "@view/page_v3/PersonalCenter/RedemptioncodeList";
import { IMAGE_TYPE } from '@utils/CONST'
import Service from '@view/page/Service';
import HomemainSidebar from '@view/page_v3/components/HomemainSidebar'
import ProjectSidebar from '@view/page_v3/components/ProjectSidebar'
import styles from './pc.module.scss'
import { ProjectContextProvider } from "@view/page_v3/hooks/ProjectContext";
import { resolveRouteMeta } from './seoMeta';

// 批量生产
import BatchProductImages from "@view/page_v3/BatchProductImages"
import BatchProductUpload from "@view/page_v3/BatchProductImages/UploadPage"
import BatchProductConfig from "@view/page_v3/BatchProductImages/ConfigPage"
import BatchProductResults from "@view/page_v3/BatchProductImages/ResultsPage"
import BatchProductSelected from "@view/page_v3/BatchProductImages/SelectedPage"
import RedemptioncodePage from "@view/page_v3/BatchProductImages/components/RedemptioncodePage"
import { BatchImagesContextProvider } from "@view/page_v3/BatchProductImages/BatchImagesContext"

// 素材管理
import MaterialManageLayout from "@view/page_v3/MaterialManage/MaterialManageLayout"
import { MaterialManageContextProvider } from "@view/page_v3/MaterialManage/hooks/MaterialManageContext"

// 引入组件
const HomePage = lazy(() => import('@view/page/HomePage'))
const HomePageMaster = lazy(() => import('@view/page/HomePage/indexMaster.jsx'))
const HomePageMasterSub = lazy(() => import('@view/page/HomePage/indexMasterSub.jsx'))
const BannerActivity = lazy(() => import('@view/page/HomePage/bannerActivity.jsx'))
const Membership = lazy(() => import('@view/page/MemberShip'))
const ConnectUs = lazy(() => import('@view/page/ConnectUs'))

const Pay = lazy(() => import('@view/Pay'))
const ImageExtraction = lazy(() => import('@view/page_v3/AiEdit/imageExtraction'))

function ImageResizeRedirect() {
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const targetQuery = new URLSearchParams({ menuKey: 'imageResize' })
    const imageUrl = query.get('url')
    if (imageUrl) targetQuery.set('url', imageUrl)
    return <Navigate replace to={`/home/aiEdit?${targetQuery.toString()}`} />
}

function HomeLayout() {
    const location = useLocation();
    const hideSidebar = location.pathname === '/home/homemain/creativeToImage';

    return (
        <div className={styles.Home_main}>
            {!hideSidebar && <HomemainSidebar />}
            <div style={{ flex: 1, overflow: "hidden" }}>
                <Outlet />
            </div>
        </div>
    )
}

function BatchLayout() {
    const location = useLocation();
    const hideSidebar = location.pathname.includes('/config') ||
        location.pathname.includes('/detail') ||
        location.pathname.includes('/selected') ||
        location.pathname.includes('/upload')

    return (
        <div className={styles.Home_main}>
            {/* {!hideSidebar && <HomemainSidebar />} */}
            <div style={{ flex: 1, overflow: "hidden" }}>
                <Outlet />
            </div>
        </div>
    )
}

function MyProjectLayout() {
    return (
        <div className={styles.Pro_main}>
            <ProjectSidebar />
            <div style={{ flex: 1, overflow: "hidden" }}>
                <Outlet />
            </div>
        </div>
    )
}

function PersonalCenterLayout() {
    return (
        <div className={styles.PersonCenter_main}>
            <PersonalSidebar />
            <div style={{ flex: 1, overflowX: "auto", overflowY: "hidden" }}>
                <Outlet />
            </div>
        </div>
    )
}

export default function PcRoute() {
    const location = useLocation();
    const { globalUser, globalOrgInfo } = useContext(AppContext)
    const navigate = useNavigate()

    useEffect(() => {
        const target = document.getElementById('topView')
        if (target) target.scrollIntoView()

        const metaInfo = resolveRouteMeta(location.pathname, location.search)

        if (metaInfo?.title) document.title = metaInfo.title
        document.querySelector('meta[name="description"]')?.setAttribute('content', metaInfo.description)
        document.querySelector('meta[name="keywords"]')?.setAttribute('content', metaInfo.keywords)
    }, [location.pathname, location.search])

    const cmCount = useMemo(() => { // 违规次数;4次及以上需要封号
        return globalUser?.cmCount || 0
    }, [globalUser])
    const cmReadFlag = useMemo(() => { // 已读标记，0-未读，需要弹窗；1-已读
        return globalUser?.cmReadFlag == 0 ? globalUser?.cmReadFlag : (globalUser?.cmReadFlag || 1)
    }, [globalUser])
    const appealBeforeTime = useMemo(() => { // 申诉期限
        return globalUser?.appealBeforeTime || '--'
    }, [globalUser])

    useEffect(() => {
        if (cmCount == 0 || cmReadFlag == 1) return
        if (cmCount < 4) eventBus.emit('violationWarn', cmCount, appealBeforeTime) // 违规警告
        else eventBus.emit('suspenNotice', cmCount, 1, appealBeforeTime) // 封号提醒
    }, [cmCount, cmReadFlag, appealBeforeTime])


    useEffect(() => {
        //活动弹窗
        eventBus.emit('EVENTPOPUP')

        const pathname = location.pathname;
        if (['/home/homemain/clothes',
            '/home/homemain/model',
            '/home/homemain/background',
            '/home/homemain/shoesTryon',
            '/home/homemain/model_video',
            '/home/homemain/model_video_img',
            '/home/homemain/poseTryon',
            '/home/homemain/grassPlant',
            '/home/homemain/smartDetailPage',
            '/home/homemain/watermarkRemove',
            '/home/homemain/simTryon',
            '/home/homemain/glassesTryon',
            '/home/homemain/creativeToImage'].includes(pathname)) {
            sessionStorage.setItem('lastRouteClothes', pathname);
        } else if (['/home/homemain/commodity'].includes(pathname)) {
            sessionStorage.setItem('lastRouteCommodity', pathname);
        } else {
            sessionStorage.removeItem('lastRouteClothes');
            sessionStorage.removeItem('lastRouteCommodity');
            sessionStorage.removeItem('imgResizeCache')
        }
    }, [location.pathname]);

    // 切换成企业成员账号退出
    useEffect(() => {
        if (!globalOrgInfo?.current?.role) return
        const pathname = location.pathname;
        if (['/home/personalCenter/personalTransaction',
            '/home/personalCenter/personalOrder',
            '/home/personalCenter/memberManage',
            '/home/personalCenter/personalInformation'].includes(pathname) &&
            globalOrgInfo?.current?.role != 'admin') {
            navigate(`/home/homemain/clothes`)
        }
    }, [location.pathname, globalOrgInfo])


    return (
        <Routes>
            <Route path="/" element={<PcLayout />}>
                <Route path="" element={<HomePage />} />
                <Route path="homePageMaster" element={<HomePageMaster />} />
                <Route path="homePageMasterSub" element={<HomePageMasterSub />} />
                <Route path="bannerActivity" element={<BannerActivity />} />
                <Route path="membership" element={<Membership />} />
                <Route path="connect_us" element={<ConnectUs />} />
                <Route path="service" element={<Service.HomePage />}></Route>
                {/* <Route path="home/*" element={<Home /> } /> */}
                <Route path="home/"
                    element={<div
                        style={{
                            height: `calc(100% - var(--header-height, 0px) - 50px)`,
                            overflow: 'hidden',
                            position: 'relative'
                        }}
                    ><Outlet /></div>}>
                    <Route path="homemain/*" element={<HomeLayout />}>
                        <Route path="model" element={<HomemainLayout imageType={IMAGE_TYPE.MODEL} key={IMAGE_TYPE.MODEL} />}></Route> {/*换模特*/}
                        <Route path="background" element={<HomemainLayout imageType={IMAGE_TYPE.BACKGROUND} key={IMAGE_TYPE.BACKGROUND} />}></Route> {/*换背景*/}
                        <Route path="clothes" element={<HomemainLayout imageType={IMAGE_TYPE.CLOTHES} key={IMAGE_TYPE.CLOTHES} />}></Route> {/*AI试衣*/}
                        <Route path="shoesTryon" element={<HomemainLayout imageType={IMAGE_TYPE.SHOES} key={IMAGE_TYPE.SHOES} />}></Route> {/*鞋子上脚*/}
                        <Route path="commodity" element={<HomemainLayout imageType={IMAGE_TYPE.COMMODITY} key={IMAGE_TYPE.COMMODITY} />}></Route> {/*商品图*/}
                        <Route path="commodityRecolor" element={<HomemainLayout imageType={IMAGE_TYPE.COMMODITYRECOLOR} key={IMAGE_TYPE.COMMODITYRECOLOR} />}></Route> {/*商品换色*/}
                        <Route path="clothRecolor" element={<HomemainLayout imageType={IMAGE_TYPE.CLOTH_RECOLOR} key={IMAGE_TYPE.CLOTH_RECOLOR} />}></Route> {/*服饰换色*/}
                        <Route path="commodity_video" element={<HomemainLayout imageType={IMAGE_TYPE.COMMODITY_VIDEO} key={IMAGE_TYPE.COMMODITY_VIDEO} />}></Route> {/*商品视频*/}
                        <Route path="model_video" element={<HomemainLayout imageType={IMAGE_TYPE.MODEL_VIDEO} key={IMAGE_TYPE.MODEL_VIDEO} />}></Route> {/*动作模仿*/}
                        <Route path="model_video_img" element={<HomemainLayout imageType={IMAGE_TYPE.IMAGE_TO_VIDEO} key={IMAGE_TYPE.IMAGE_TO_VIDEO} />}></Route> {/*图生视频*/}
                        <Route path="poseTryon" element={<HomemainLayout imageType={IMAGE_TYPE.POSE_TRYON} key={IMAGE_TYPE.POSE_TRYON} />}></Route> {/*姿势裂变*/}
                        <Route path="glassesTryon" element={<HomemainLayout imageType={IMAGE_TYPE.GLASSES_TRYON} key={IMAGE_TYPE.GLASSES_TRYON} />}></Route> {/*眼镜试戴*/}
                        <Route path="necklaceTryon" element={<HomemainLayout imageType={IMAGE_TYPE.NECKLACE_TRYON} key={IMAGE_TYPE.NECKLACE_TRYON} />}></Route> 项链试戴
                        <Route path="simTryon" element={<HomemainLayout imageType={IMAGE_TYPE.SIM_TRYON} key={IMAGE_TYPE.SIM_TRYON} />}></Route> {/*同版型试衣*/}
                        <Route path="fusionWear" element={<HomemainLayout imageType={IMAGE_TYPE.FUSION_WEAR} key={IMAGE_TYPE.FUSION_WEAR} />}></Route> {/*搭配上身*/}
                        <Route path="creativeToImage" element={<HomemainLayout imageType={IMAGE_TYPE.CREATIVE_IMAGE_GEN} key={IMAGE_TYPE.CREATIVE_IMAGE_GEN} />}></Route> {/*AI创意生图*/}
                        <Route path="grassPlant" element={<HomemainLayout imageType={IMAGE_TYPE.GRASS_PLANT} key={IMAGE_TYPE.GRASS_PLANT} />}></Route> {/*种草图*/}
                        {/* <Route path="smartDetailPage" element={<HomemainLayout imageType={IMAGE_TYPE.SMART_DETAILA_PAGE} key={IMAGE_TYPE.SMART_DETAILA_PAGE} />}></Route> 服装详情页 */}
                        <Route path="watermarkRemove" element={<HomemainLayout imageType={IMAGE_TYPE.WATERMARK_REMOVE} key={IMAGE_TYPE.WATERMARK_REMOVE} />}></Route> {/*去水印*/}

                        <Route path="favor_detail" element={<FavorDetail />}></Route>
                        <Route path="PhotoProjectDetail" element={<PhotoProjectDetail key="project" />}></Route>
                        <Route path="*" element={<Navigate replace to="/" />} />
                    </Route>
                    {/* <Route path="personalCenter" element={<PersonalCenter key={'personal'} />}></Route>
                    <Route path="personalCenter/record" element={<PersonalCenter key={'personalRecord'} record />}></Route> */}
                    <Route path="aiedit" element={<AiEdit />}></Route>
                    <Route path="image_extraction" element={<ImageExtraction />}></Route>
                    <Route path="imageResize" element={<ImageResizeRedirect />}></Route>

                    <Route path="product" element={
                        <BatchImagesContextProvider>
                            <BatchLayout />
                        </BatchImagesContextProvider>
                    }>  {/*企业批量生图*/}
                        <Route path="redemptioncodePage" element={<RedemptioncodePage />}></Route>
                        <Route path="batchImages" element={<BatchProductImages />}></Route>
                        <Route path=":projectType/upload" element={<BatchProductUpload />}></Route>
                        <Route path=":projectId">
                            <Route path="config" element={<BatchProductConfig />}></Route>
                            <Route path="detail" element={<BatchProductResults />}></Route>
                            <Route path="selected" element={<BatchProductSelected />}></Route>
                        </Route>
                    </Route>

                    <Route path="myProject" element={
                        <ProjectContextProvider>
                            <MyProjectLayout />
                        </ProjectContextProvider>
                    }>
                        <Route path="batchImages" element={<BatchProductImages isProCenter={true} />}></Route>
                        <Route path="list" element={<MyProjectList />}></Route>
                        <Route path=":projectId/detail" element={<MyProjectDetail />}></Route>
                    </Route>

                    <Route path="personalCenter" element={<PersonalCenterLayout />}>
                        <Route path="personalTransaction" element={<PersonalTransaction />}></Route>
                        <Route path="personalOrder" element={<PersonalOrder />}></Route>
                        <Route path="personalInformation" element={<PersonalInformation />}></Route>
                        <Route path="memberManage" element={<MemberManage />}></Route>
                        <Route path="redemptioncodeList" element={<RedemptioncodeList />}></Route>
                    </Route>

                    <Route path="material" element={
                        <MaterialManageContextProvider>
                            <MaterialManageLayout />
                        </MaterialManageContextProvider>
                    }>
                    </Route>  {/*素材管理*/}

                    <Route path="service" element={<Service.Layout />}>
                        <Route path=":taskType/upload" element={<Service.UploadPage />}></Route>
                        <Route path=":taskId" element={<Service.TaskLayout />}>
                            <Route path="config" element={<Service.ConfigPage />}></Route>
                            <Route path="detail" element={<Service.DetailPage />}></Route>
                        </Route>
                        <Route path="list" element={<Service.ResultsPage />}></Route>
                    </Route>
                    <Route path="*" element={<Navigate replace to="/" />} />
                </Route>
                <Route path="pay" element={<Pay />} />
            </Route>
        </Routes>
    )
}
